import {httpsCallable} from 'firebase/functions';
import {functions} from "../base";

import React, {useState} from 'react';
import {Table, Button} from 'antd';
import {collection, query, orderBy, limit, startAfter, getDocs} from "firebase/firestore";
import {useInfiniteQuery} from '@tanstack/react-query';
import {db} from '../base';
import NavBar from "../components/NavBar";
import GeneraCodiceSconto from "../components/generaCodiceSconto";

const fetchUsers = async ({pageParam = null}) => {
    const getAllUsers = httpsCallable(functions, 'getCodiciScontoWithEmails');
    const response = await getAllUsers({pageSize: 30, lastVisible: pageParam});
    return response.data;
};


const GiftCards = () => {
    const {
        data,
        fetchNextPage,
        hasNextPage,
        isFetchingNextPage,
        isLoading
    } = useInfiniteQuery({
            queryKey: ['gift-cards'],
            queryFn: fetchUsers,
            getNextPageParam: (lastPage) => lastPage.lastVisible,
        }
    );

    const columns = [
        {
            title: 'Codice',
            dataIndex: 'id',
            key: 'id',
        },
        {
            title: 'Valore',
            dataIndex: 'punti',
            key: 'punti',
            render: (punti) => {
                return punti + '€'; // Format the date to a readable string
            }
        },
        {
            title: 'Assegnato a',
            dataIndex: 'assegnato',
            key: 'assegnato',
            render: (assegnato) => {
                return assegnato ? <b>{assegnato}</b> : <span style={{color: 'gray'}}>Non assegnato</span>
            }
        },
        {
            title: 'Creazione',
            dataIndex: 'creazione',
            key: 'creazione',
            render: (creazione) => {
                const date = new Date(creazione._seconds * 1000);
                return date.toLocaleString(); // Format the date to a readable string
            }
        },
    ];

    const dataSource = data?.pages.flatMap(page => page.data) || [];

    return (
        <>
            <NavBar/>
            <main>
                <GeneraCodiceSconto/>
                <h2>Tutte le gift cards</h2>
                <Table
                    loading={isLoading}
                    columns={columns}
                    dataSource={dataSource}
                    pagination={false} // Disable default pagination
                    rowKey="key"
                />
                <div style={{textAlign: 'center', margin: '20px 0'}}>
                    {hasNextPage && (
                        <Button onClick={() => fetchNextPage()} disabled={isFetchingNextPage}>
                            {isFetchingNextPage ? 'Loading more...' : 'Carica altri'}
                        </Button>
                    )}
                </div>
            </main>
        </>
    );
};

export default GiftCards;
